import React from "react";
import { parseFreeFieldPercentage } from "shared/utils/freeFields/utils";
import { getPercentageFormatter } from "utilities/formatter";

interface Props {
  value: string
}

const ReadonlyPercentage = ({ value }: Props) => {
  const percentageFormatter = getPercentageFormatter(5);
  const formatted = percentageFormatter.format(parseFreeFieldPercentage(value));

  return <>{formatted}</>;
};

export default ReadonlyPercentage;
